import { render, staticRenderFns } from "./AuthenticationIcon.vue?vue&type=template&id=768134c2&"
import script from "./AuthenticationIcon.vue?vue&type=script&lang=js&"
export * from "./AuthenticationIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports